import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Lock, Spinner } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        {/* Logo area */}
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#E85D24]/15 flex items-center justify-center mx-auto mb-4 border border-[#E85D24]/30">
            <Lock size={28} weight="bold" className="text-[#E85D24]" />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">Portl Sales Agent</h1>
          <p className="text-sm text-[#666] mt-1">Admin Dashboard</p>
        </div>

        {/* Login form */}
        <form onSubmit={handleSubmit} className="bg-[#121212] border border-[#2A2A2A] rounded-lg p-6 space-y-4">
          <div>
            <label htmlFor="email" className="block text-xs font-medium text-[#888] mb-1.5">Email</label>
            <input
              id="email"
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full bg-[#0A0A0A] border border-[#2A2A2A] rounded px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#E85D24] transition-colors placeholder:text-[#444]"
              placeholder="admin@portl.co"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-xs font-medium text-[#888] mb-1.5">Password</label>
            <input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#0A0A0A] border border-[#2A2A2A] rounded px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#E85D24] transition-colors placeholder:text-[#444]"
              placeholder="Password"
            />
          </div>

          {error && (
            <div data-testid="login-error" className="bg-[#FF3B30]/10 border border-[#FF3B30]/40 rounded px-3 py-2 text-[#FF3B30] text-xs">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#E85D24] hover:bg-[#E85D24]/85 disabled:opacity-50 text-white font-semibold py-2.5 rounded text-sm transition-all duration-200 flex items-center justify-center gap-2"
          >
            {loading ? <Spinner size={18} className="animate-spin" /> : null}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center text-[11px] text-[#444] mt-6">Powered by Portl Sales Agent</p>
      </div>
    </div>
  );
}
